export default __webpack_public_path__ + "static/media/back.7abe5939.png";